const throwUnsupportedError = (feature: string) => {
  throw new Error(`${feature} is not available on this platform`);
};

export default throwUnsupportedError;
